import React from 'react'
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from "@mui/material/SnackbarContent";
import Slide from '@mui/material/Slide';
import {Box} from "@mui/system";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from "@mui/material/IconButton";

let _this;

const styles = {
    colorBg: {
        backgroundColor: '#63636d',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    },
    icon: {
        fontSize: 20,
    },
    container: {
        minWidth: '200px',
        backgroundColor: '#FFFFFF',
        borderRadius: '5px',
        px: '20px',
        py: '65px',
    },
    messageContainer: {
        maxWidth: {xs: 'unset', md: '400px'},
        m: '3px'
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: "space-between",
        mb: '4px'
    },
    iconContainer: {
        ml: '30px',
        mb: '2px'
    },
    closeIcon: {
        color:'#0F0A06',
        fontSize: '20px'
    },
    titleContainer: {
        display: 'flex', alignItems: 'center'
    },
    titleIcon: {
        fontSize: '20px',
        mr: '12px',
    },
    title: {
        fontFamily: 'FustatExtraBold',
        fontSize: '15.3px',
        color: '#0C2728',
        letterSpacing: '-0.01em',
    },
    message: {
        fontFamily: 'FustatSemiBold',
        fontSize: '15px',
        color: '#383737',
        letterSpacing: '-0.01em',
    },
    footer: {
        fontFamily: 'FustatSemiBold',
        fontSize: '15px',
        color: '#125E82',
        letterSpacing: '-0.01em',
        mt: '10px'
    }
};

function SlideTransition(props) {
    return <Slide {...props} direction="right" />;
}

class ToastProvider extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            snackbarOpen: false,
            autoHideDuration: 3000,

            headerIcon: '',
            headerText: '',
            message: '',
            footer: '',
            Transition: SlideTransition
        };
        _this = this;
    }

    snackbarClose = () => {
        this.setState({snackbarOpen: false});
    };

    static snackbarClose = () => {
        _this.snackbarClose();
    };

    static showMessage(message, options){
        const {
            headerIcon = '',
            headerText = '',
            footer = '',
            autoHideDuration = undefined
        } = options || {};

        _this.setState({
            snackbarOpen: true,

            headerIcon: headerIcon,
            headerText: headerText,
            message: message,
            footer: footer,
            autoHideDuration,
            Transition: SlideTransition
        })
    }


    render() {
        const { headerIcon, headerText, message, footer, snackbarOpen, autoHideDuration } = this.state;

        return (
            <div>
                <Snackbar
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    open={snackbarOpen}
                    onClose={this.snackbarClose}
                    ContentProps={{ 'aria-describedby': 'message-id' }}
                    autoHideDuration={autoHideDuration}
                    TransitionComponent={this.state.Transition}
                >
                    <SnackbarContent
                        message={
                            <Box sx={styles.messageContainer}>
                                <Box sx={styles.header}>
                                    {headerText && (
                                        <Box sx={styles.titleContainer}>
                                            { headerIcon &&  <Box sx={styles.titleIcon}>{headerIcon}</Box> }
                                            <Box sx={styles.title}>{headerText}</Box>
                                        </Box>
                                    )}

                                    {(headerIcon || headerText) && (
                                        <Box sx={styles.iconContainer}>
                                            <IconButton size="small" onClick={this.snackbarClose}>
                                                <CloseIcon sx={styles.closeIcon} />
                                            </IconButton>
                                        </Box>
                                    )}
                                </Box>

                                <Box sx={headerIcon ? { pl: '30px' } : {}}>
                                    <Box sx={styles.message}>{message}</Box>
                                    <Box sx={styles.footer}>{footer}</Box>
                                </Box>
                            </Box>
                        }
                        style={styles.container}
                    />
                </Snackbar>
            </div>
        );
    }
}
export { ToastProvider };
